module.exports = __webpack_public_path__ + "img/logo-cvit.b66bfe0c.png";